import getTheme from './get-theme'
const theme = getTheme()
const colors = require(`../themes/${theme}/colors.js`)

export default colors
